__turbopack_context__.v({
  "className": "gpOlYa_className",
  "variable": "gpOlYa_variable",
});
